export default __webpack_public_path__ + "static/media/warning_tick.8e83c110.svg";